import React from 'react';
import ReactDOM from 'react-dom';
import AppProvider from 'hooks';

import { msalInstance } from 'configs/authConfig';
import { MsalProvider } from '@azure/msal-react';
import App from './App';

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <AppProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AppProvider>
  </MsalProvider>,
  document.getElementById('root'),
);
